import * as React from 'react';
import useI18n from 'src/hooks/useI18n';

import {TableBottomBar} from '@spaced-out/ui-design-system/lib/components/Table';
import {SubTitleExtraSmall} from '@spaced-out/ui-design-system/lib/components/Text';
import {Pagination} from '@spaced-out/ui-design-system/lib/components/Pagination';

import {JOURNEY_PAGE_SIZE, itemsOnPageText} from 'src/utils/analytics-genesis';


type AllTableFooterProps = {
  pageNumber: number;
  totalPages: number;
  handlePageChange: (page?: number | null | undefined) => void;
  total: number;
  /**
   * Items per page used to render the "Items on page: X-Y of Total" text.
   * Defaults to JOURNEY_PAGE_SIZE (10) for backward compatibility with
   * existing callers. Pass explicitly when the caller uses a different
   * page size, otherwise the range text will be wrong (e.g. a 5-per-page
   * table showing "Items on page: 1-10 of 3").
   */
  pageSize?: number;
};

const AllTableFooter = ({
  pageNumber,
  totalPages,
  handlePageChange,
  total,
  pageSize = JOURNEY_PAGE_SIZE,
}: AllTableFooterProps) => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  return (
    <TableBottomBar>
      <Pagination
        currentPage={pageNumber}
        totalPages={totalPages}
        onChange={handlePageChange}
      >
        <SubTitleExtraSmall color="secondary">
          {itemsOnPageText(pageNumber, pageSize, total, t)}
        </SubTitleExtraSmall>
      </Pagination>
    </TableBottomBar>
  );
};

export default AllTableFooter;
